// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Rdqz","requiredAsterisk":"Info_requiredAsterisk__2QFhP"};